<template>
  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" :style="{display: showflag?'block':'none'}">
    <div class="delete-content">
        <div class="right">
            <a title="关闭" href="javascript:;">
                <button type="button" class="dle dle-btn font16" @click="close()">
                  <!--<span class="glyphicon glyphicon-remove"></span>-->
                  <span class="remove-icon-box"></span>
                </button>
            </a>
        </div>
        <div class="delt-cont">
            <div class="dn">
                <span class="img left"><img src="/static/images/logo-s.png" alt="user"></span>
                <div class="delt-bot">
                    <span class="t"> {{ message }} </span>
                    <button type="button" class="btn btn-del right30" @click="close()">确 定</button>
                </div>
            </div>
        </div>
    </div>
  </div>
  <div class="modal-backdrop fade in" :style="{display: showflag?'block':'none'}"></div>
</template>

<script>
export default {

  name: 'AlertView'

}
</script>

<style scoped>
  .delete-content {
    /*display: none;*/
    display: block !important;
    background-color: #ffffff;
    border: 1px solid #3270ad;
    border-radius: 6px;
    box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
    /*width: 320px;*/
    width: 80%;
    color: #3270ad;
    padding: 0 0 10px;
    position: absolute;
    top: 30%;
    margin: auto;
    margin-left: 10%;
    z-index: 9999;
  }

  .delete-content .delt-cont {
    overflow: hidden;
  }

  #dialog {
    z-index: 1200;
  }

  .dle-btn {
    float: right;
    border: none;
    margin-top: 10px;
    margin-right: 20px;
  }

  .remove-icon-box {
    width: 20px;
    height: 20px;
    display: block;
    /*background-image: url("../../static/images/remove-icon.png");*/
    background-image: url("../../static/images/remove-icon.svg");
    background-size: cover;
  }

  /*.delt-bot .btn {*/
    /*background: #FFFFFF;*/
    /*box-shadow: 1px 2px 5px 0px #3270ad;*/
  /*}*/
</style>



/** WEBPACK FOOTER **
 ** Alert.vue?0e75eae5
 **/